"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _recompose = require("recompose");

var _rcProgress = require("rc-progress");

var _qaSelector = _interopRequireDefault(require("@influitive/qa-selector"));

var _defaults = _interopRequireDefault(require("../theme-provider/defaults"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizesMap = {
  'small': 2,
  'medium': 4,
  'large': 6
};

var widthFor = function widthFor(size) {
  return sizesMap[size];
};

var _default = (0, _recompose.compose)((0, _recompose.defaultProps)({
  percent: 0,
  size: 'medium',
  color: _defaults.default.colors.primary[0]
}), (0, _recompose.setPropTypes)({
  percent: _propTypes.default.number,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  color: _propTypes.default.string,
  className: _propTypes.default.string
}), (0, _recompose.setDisplayName)('ProgressBar'))(function (_ref) {
  var percent = _ref.percent,
      color = _ref.color,
      size = _ref.size,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["percent", "color", "size", "className"]);

  return (0, _core.jsx)(_rcProgress.Line, {
    "data-qa": (0, _qaSelector.default)('sec-progress', rest),
    className: className,
    percent: percent,
    strokeWidth: widthFor(size),
    trailWidth: widthFor(size),
    strokeColor: color
  });
});

exports.default = _default;